
import Component from 'vue-class-component';
import Dataset from '@/shared/data/model/Dataset';
import AutoFlex from './AutoFlex.vue';

@Component
export default class ThreeCols333333 extends AutoFlex {
  get autoFlexConfig(): Dataset {
    const [slot1, slot2, slot3] = this.slotsNames;
    const config: Dataset = {
      vertical: false,
    };
    if (slot1) {
      config[`${slot1}Basis`] = '33.33%';
      config[`${slot1}Grow`] = '0';
      config[`${slot1}Shrink`] = '0';
    }
    if (slot2) {
      config[`${slot2}Basis`] = '33.33%';
      config[`${slot2}Grow`] = '0';
      config[`${slot2}Shrink`] = '0';
    }
    if (slot3) {
      config[`${slot3}Basis`] = '33.33%';
      config[`${slot3}Grow`] = '0';
      config[`${slot3}Shrink`] = '0';
    }
    return config;
  }
}
